import React from 'react';

import { INPUT_TYPE_DECIMAL, InputWithField } from 'components/Input';
import { HIRE_PURCHASE_RESIDUAL_VALUE } from 'modules/Inquiry/Form/formFields';

const HirePurchaseResidualValue = () => {
  return <InputWithField name={HIRE_PURCHASE_RESIDUAL_VALUE} type={INPUT_TYPE_DECIMAL} />;
};

export default HirePurchaseResidualValue;
